var map = {
	"./32.png": "17a0",
	"./64.png": "1307",
	"./AkinSoft.png": "9a60",
	"./Beymen.png": "e33b",
	"./Boyner.png": "a8bb",
	"./CicekSepeti.png": "ce8f",
	"./Demsan.png": "28dd",
	"./Excel.png": "9fed",
	"./Gittigidiyor.png": "06eb",
	"./Ideasoft.png": "a248",
	"./Idefix.png": "59bd",
	"./Ikas.png": "0b02",
	"./LastBrand.png": "6727",
	"./LcWaikiki.png": "79e2",
	"./Logo-della-Shopify50px.png": "f5b3",
	"./Modanisa.png": "16e1",
	"./N11.png": "4f2d",
	"./PHP-tr.png": "bb3b",
	"./Pazarama.png": "b1bb",
	"./Shopify.png": "1f79",
	"./Sopyo.png": "ac72",
	"./Tahsildar.png": "d0be",
	"./Temu.png": "1a16",
	"./Tsoft.png": "a004",
	"./WooCommerce_logo50px.png": "b631",
	"./Woocommerce.png": "76ca",
	"./aras.png": "af99",
	"./azall.png": "3c9d",
	"./ciceksepeti50px.png": "89b8",
	"./dhl.png": "ec5c",
	"./efatura.png": "3dee",
	"./etsy.png": "f749",
	"./etsy50px.png": "122a",
	"./favicon-backup.ico": "b784",
	"./favicon.ico": "91a0",
	"./favicon.png": "6d55",
	"./gfuzum-1.png": "5462",
	"./gfuzum.png": "323d",
	"./gittigidiyor50px.png": "2beb",
	"./hepsiburada-logo-1024jpg50px.png": "81c2",
	"./hepsiburada.png": "5e87",
	"./hepsijet.png": "fa9e",
	"./ideasoft50px.png": "e150",
	"./ikas50px.jpg": "0d54",
	"./kargonomi.png": "1a1b",
	"./logo.png": "a4ef",
	"./mng.png": "d3b3",
	"./mosanisa50px.png": "90a4",
	"./n11png50px.png": "3a40",
	"./ozon.png": "a735",
	"./ozon50px.png": "11b3",
	"./ptt.png": "ef6f",
	"./ptt_logo50px.png": "1044",
	"./pttavm.png": "5bc4",
	"./pttavm50px.png": "a4bc",
	"./surat.png": "3de4",
	"./ticimax.png": "0e7c",
	"./ticimax50px.png": "34e9",
	"./ticimaxxx50px.png": "8b80",
	"./tr-pazarama.png": "5401",
	"./trendyol-express.png": "0a54",
	"./trendyol-logo50px.png": "484f",
	"./trendyol.png": "8697",
	"./tsoft_logo50px.png": "43ba",
	"./tticimax50px.png": "2620",
	"./yurtici.png": "4a03",
	"./ıkas.jpg": "c9b4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d47a";